/**
 * @generated SignedSource<<a584f7d75d0313da4dc84d8c300f6fb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaregiverTravelDistanceInput = {
  travelDistance: number;
  clientMutationId?: string | null;
};
export type TravelDistanceMutation$variables = {
  input: CaregiverTravelDistanceInput;
};
export type TravelDistanceMutation$data = {
  readonly updateCaregiverTravelDistance: {
    readonly travelDistance: number;
  } | null;
};
export type TravelDistanceMutation = {
  variables: TravelDistanceMutation$variables;
  response: TravelDistanceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CaregiverTravelDistancePayload",
    "kind": "LinkedField",
    "name": "updateCaregiverTravelDistance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelDistance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelDistanceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TravelDistanceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "74f189eeb8a3f7f97515fb6c419de93e",
    "id": null,
    "metadata": {},
    "name": "TravelDistanceMutation",
    "operationKind": "mutation",
    "text": "mutation TravelDistanceMutation(\n  $input: CaregiverTravelDistanceInput!\n) {\n  updateCaregiverTravelDistance(input: $input) {\n    travelDistance\n  }\n}\n"
  }
};
})();

(node as any).hash = "58479927f707d624659461388222e8ef";

export default node;
